import type { RouteRecordMainRaw } from '@kelan-ui/vue/types'
import type { RouteRecordRaw } from 'vue-router'
import { $t } from '@/locales'
import pinia from '@/store'
import WeComScheduleBoard from '@/views/wecom_schedule_board/index.vue'
import { WE_COM_SCHEDULE_BOARD_PATH } from './history'
import AiVoiceCreation from './modules/ai-voice-creation'
import DoctorSchedules from './modules/doctor-schedules'
import EcosystemEntities from './modules/ecosystem-entities'
import MetadataCenter from './modules/metadata-center'
import OssUploadTest from './modules/oss-upload-test'
import WeComCollaboration from './modules/wecom-collaboration'

// 固定路由（默认路由）
const constantRoutes: RouteRecordRaw[] = [
  {
    path: WE_COM_SCHEDULE_BOARD_PATH,
    name: 'wecomScheduleBoard',
    component: WeComScheduleBoard,
    meta: {
      public: true,
      title: '出诊看板',
    },
  },
  {
    path: '/:all(.*)*',
    name: 'notFound',
    component: () => import('@/views/[...all].vue'),
    meta: {
      title: '找不到页面',
    },
  },
]

// 系统路由
const systemRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/index.vue'),
    meta: {
      breadcrumb: false,
    },
    children: [
      {
        path: '',
        component: () => import('@/views/index.vue'),
        meta: {
          title: $t(useAppSettingsStore(pinia).settings.app.home.title),
          icon: 'i-ant-design:home-twotone',
          breadcrumb: false,
          copyright: false,
        },
      },
      {
        path: 'reload',
        name: 'reload',
        component: () => import('@/views/reload.vue'),
        meta: {
          title: $t('app.route.reload'),
          breadcrumb: false,
        },
      },
    ],
  },
]

constantRoutes.push(...systemRoutes)

// 动态路由（异步路由、导航菜单路由）
const asyncRoutes: RouteRecordMainRaw[] = [
  {
    meta: {
      title: '工作台',
      icon: 'i-ri:function-ai-line',
      sort: 100,
    },
    children: [
      EcosystemEntities,
      DoctorSchedules,
      WeComCollaboration,
      MetadataCenter,
    ],
  },
  {
    meta: { title: '系统工具', icon: 'i-lucide:wrench', sort: 80 },
    children: [OssUploadTest],
  },
  {
    meta: {
      title: 'AI能力中心',
      icon: 'i-ri:ai-agent-line',
      sort: 90,
    },
    children: [
      AiVoiceCreation,
    ],
  },
]

export {
  asyncRoutes,
  constantRoutes,
  systemRoutes,
}
